export default {
  "content": "<path fill=\"#22264C\" d=\"M3.02 3.551h2.799v2.514H3.033v3.11H0V0h6.195v2.579H3.02z\" fill-rule=\"evenodd\"/>",
  "attrs": {
    "width": "7",
    "height": "10",
    "viewBox": "0 0 7 10",
    "xmlns": "http://www.w3.org/2000/svg"
  }
};